import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Portal from 'src/layout/Portal/Portal';
import useEventListener from 'src/hooks/useEventListener';
import { TModalFullScreen, TModalSize } from 'src/type/modal-type';
import Button, { IButtonProps } from 'src/components/bootstrap/Button';
import FormGroup from 'src/components/bootstrap/forms/FormGroup';
import Input from 'src/components/bootstrap/forms/Input';
import Select from 'src/components/bootstrap/forms/Select';
import Option from 'src/components/bootstrap/Option';
import { BsXCircleFill } from 'react-icons/bs';
import { PaymentServices } from 'src/services/PaymentServices';
import showNotification from 'src/components/extras/showNotification';
import { getStorage } from 'src/utils/utils';
import ModalLoading from 'src/components/ModalLoadingClock';

export default function ModalTranferMoney({ isOpen, exit, data, fetchSumSettlements, t }) {
	const [amount, setAmount] = useState(0);
	const [google2Fa, set2Fa] = useState('');
	const [loading, setLoading] = useState(false);

	const handleTranferMoney = () => {
		setLoading(true);
		if (google2Fa !== undefined) {
			if (amount !== 0) {
				
				PaymentServices.transfer({
					bank_account_id: data?._id,
					amount: parseFloat(amount),
					token: google2Fa,
				})
					.then(() => {
						exit();
						fetchSumSettlements();
						showNotification(
							<span className='d-flex align-items-center'></span>,
							`${t('txt_successfully')}`,
						);
					})
					.catch((err) => {
						showNotification(
							<span className='d-flex align-items-center'></span>,
							`${err?.response?.data?.message}`,
						);
					})
					.finally(() => {
						setTimeout(() => {
							setLoading(false);
						}, 5000);
					});
			}
		} else {
			showNotification(<span className='d-flex align-items-center'></span>, ``);
		}
	};

	return (
		<div>
			<Portal>
				<AnimatePresence mode='wait'>
					{isOpen && (
						<>
							<motion.div
								initial={{ scale: 0 }}
								animate={{ rotate: 0, scale: 1 }}
								transition={{
									type: 'spring',
									stiffness: 260,
									damping: 20,
								}}
								key='modal'
								className='modal show'
								style={{ display: 'block' }}
								tabIndex={-1}
								aria-hidden='true'>
								<div
									className='modal-dialog
                                modal-dialog-scrollable
                                modal-dialog-centered'>
									<div className='modal-content'>
										<div className='div_edit_bar'>
											<div className='fw-bold h5'>{t('txt_tranfer')}</div>
											<div className='div_exit' onClick={() => exit()}>
												<BsXCircleFill
													style={{ width: '15px', height: 'auto' }}
												/>
											</div>
										</div>
										<hr style={{ margin: '0px 0px 1rem 0px' }} />
										<div className='div_edit_content'>
											<FormGroup
												label={t('txt_bank_name')}
												// style={{ marginTop: '1rem' }}
											>
												<Input
													disabled
													className='input_search'
													value={data?.bank_name}
												/>
											</FormGroup>
											<FormGroup
												label={t('txt_bank_account_name')}
												style={{ marginTop: '1rem' }}>
												<Input
													disabled
													className='input_search'
													value={data?.bank_account_name}
												/>
											</FormGroup>
											<FormGroup
												label={t('txt_account_number')}
												style={{ marginTop: '1rem' }}>
												<Input
													disabled
													className='input_search'
													value={data?.bank_account_number}
												/>
											</FormGroup>

											<FormGroup
												label={t('txt_amount')}
												style={{ marginTop: '1rem' }}>
												<Input
													className='input_search'
													type='text'
													value={amount}
													onChange={(e) => setAmount(e.target.value)}
												/>
											</FormGroup>

											<FormGroup label='2FA' style={{ marginTop: '1rem' }}>
												<Input
													required
													className='input_search'
													type='text'
													value={google2Fa}
													onChange={(e) => set2Fa(e.target.value)}
												/>
											</FormGroup>

											<Button
												onClick={handleTranferMoney}
												className='btn_save_edit'>
												<span>{t('txt_confirm')}</span>
											</Button>
										</div>
									</div>
								</div>
							</motion.div>
							<div className='modal-backdrop show'></div>
						</>
					)}
				</AnimatePresence>
				<ModalLoading isOpen={loading} />
			</Portal>
		</div>
	);
}
